module.exports = __webpack_public_path__ + "media/theme/sample__dmm-71dc98c5.png";